import React from 'react';
import { PolotnoContainer, SidePanelWrap, WorkspaceWrap } from 'polotno';
import { Toolbar } from 'polotno/toolbar/toolbar';
import { PagesTimeline } from 'polotno/pages-timeline';
import { ZoomButtons } from 'polotno/toolbar/zoom-buttons';
import { SidePanel, DEFAULT_SECTIONS } from 'polotno/side-panel';
import { Workspace } from 'polotno/canvas/workspace';
import '@blueprintjs/core/lib/css/blueprint.css';
import { createStore } from 'polotno/model/store';
//import SizePanel from './SizePanel'; // Importer le panneau de tailles
//import CustomSizesPanel from './CustomSizesPanel'; // Importer le panneau de tailles personnalisées
import { ResizePanel } from './resize-panel';
import { PhotosPanel } from './custom-photos';
import { UploadPanel } from './upload-panel';
import { TemplatesSection } from './templates-panel';
import { SaveToJsonButton } from './save-to-json';
import { DownloadButton } from 'polotno/toolbar/download-button';
import { Button } from '@blueprintjs/core';
import { handleTemplateAction } from './templateHandler.js';


const ResizeSection = DEFAULT_SECTIONS.find(
  (section) => section.name === 'size'
);
// overwrite its panel component
ResizeSection.Panel = ResizePanel;

const CustomPhotosSection = DEFAULT_SECTIONS.find(
  (section) => section.name === 'photos'
);
// overwrite its panel component
CustomPhotosSection.Panel = PhotosPanel;

const CustomUploadSection = DEFAULT_SECTIONS.find(
  (section) => section.name === 'upload'
);
CustomUploadSection.Panel = UploadPanel;

const store = createStore({
  key: 'GyzeMJyfbcNXQ_udYWRH', // Remplacez par votre clé API Polotno
  showCredit: true,
});

// Ajouter une page avec une taille spécifique
store.addPage().setSize({
  width: 1290, // Largeur en pixels
  height: 2796,  // Hauteur en pixels
});

const sections = [TemplatesSection, ...DEFAULT_SECTIONS];

const ActionControls1 = ({ store }) => {
  return (
    <div>
      <DownloadButton store={store} />
      <Button
        intent="primary"
	id="save-btn"
      >
        Save
      </Button>
    </div>
  );
};

export const Editor = () => {
  return (
    <div>
      <PolotnoContainer style={{ width: '100vw', height: '100vh' }}>
        <SidePanelWrap>
<SidePanel store={store} sections={sections}  />
        </SidePanelWrap>
        <WorkspaceWrap>
          <Toolbar store={store} downloadButtonEnabled components={{
ActionControls: ActionControls1,        
}} />
          <Workspace store={store} />
          <ZoomButtons store={store} />
          <PagesTimeline store={store} />
        </WorkspaceWrap>
      </PolotnoContainer>
    </div>
  );
};

export { store };

